// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyPolicy_root__22CFM","section":"PrivacyPolicy_section__33d1H","table":"PrivacyPolicy_table__3eUhe"};